export const useSsrEffect = (cb: () => void) => {
  if (typeof window === 'undefined') {
    cb();
  }
};
